import * as DialogPrimitive from '@radix-ui/react-dialog';

import { SVGIcon } from '@paid-ui/icons';

import { styled } from '../design-tokens';
import { Logo } from '../logo';
import { Space } from '../space';

export const DialogClose = DialogPrimitive.Close;

export const HelpFormMainContent = styled(Space, {
  padding: '30px',
});

export const HelpFormHeader = styled(Space, {
  width: '100%',
});

export const HelpFormTitle = styled(DialogPrimitive.Title, {
  color: '$fg',
  fontSize: '22px',
  fontWeight: '$semibold',
  lineHeight: '27px',
  ellipsis: '100%',
  userSelect: 'none',
});

export const HelpFormDescription = styled(DialogPrimitive.Description, {
  color: '$fg',
  fontSize: '16px',
  fontWeight: '$normal',
  lineHeight: '22px',
  userSelect: 'none',
});

export const HelpFormIconButton = styled('button', {
  all: 'unset',
  boxSizing: 'border-box',
  padding: '6px',
  size: '32px',
  cursor: 'pointer',
});

export const HelpFormSVGIcon = styled(SVGIcon, {
  'size': '20px',

  '@hover': {
    'color': '$fgSecondary',
    'transition': 'color 100ms',

    '&:hover': {
      color: '$blue',
    },
  },
});

export const HelpFormClose = styled(DialogPrimitive.Close, {
  position: 'absolute',
  top: '30px',
  right: '30px',
});

export const HelpFormFooter = styled('footer', {
  width: '100%',
});

export const HelpFormLogo = styled(Logo, {
  height: '27px',
  flexShrink: 0,
});
